import React from "react";
import { Route, Redirect } from "react-router-dom";

import { useAuth } from '../../contexts/auth'
import { useCompany } from '../../contexts/Company';

const ProtectedRoute = ({ children, ...rest }) => {
    const { user } = useAuth();
    const company = useCompany();

    if (company && (company.simple_mode || company.demo)) {
        if (user) {
            // Redirigir al usuario a la página de inicio de sesión
            return <Redirect to="/code" />;
        } else {
            // Mostrar la ruta protegida solo si no hay usuario logueado
            return <Route {...rest}>{children}</Route>;
        }
    } else {
        // Mostrar la ruta protegida independientemente del estado de inicio de sesión
        return <Route {...rest} render={() => (user !== null) ? children : <Redirect to='/code' />} />;
    }
}

export default ProtectedRoute;
